export default __webpack_public_path__ + "locales/vi/Common.json?hash=44a21c98d3f2d10d32a6ef7145ff52eb";